export default "__VITE_ASSET__CoV$VZbA__"